export default {
    exec: (value) => value.length < 8 || !(/(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])/.test(value)) || false,
    message: 'passwordFormat'
}
